// extracted by mini-css-extract-plugin
export var inputGroupSm = "styles-module--input-group-sm--1YgHk";
export var inputGroupLg = "styles-module--input-group-lg--1VFCM";
export var megamenuCol = "styles-module--megamenu-col--2t_jJ";
export var heading = "styles-module--heading--1aYul";
export var megamenuItems = "styles-module--megamenu-items--RtH9V";